import React, { useEffect, useState } from 'react';
import { useStyles } from './styles';
import { Box, Button, Typography, TextareaAutosize, Grid } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme, styled } from '@material-ui/core/styles';
import Rating from '@material-ui/lab/Rating';
import {
  verydisappointed, verydisappointedfill, disappointed,
  disappointedfill, neutral, neutralfill, satisfied, satisfiedfill,verysatisfied, verysatisfiedfill, checkmark
} from "../../FeedBackComp/svgs.js";
import { updateMyFeedbackProtected } from '../../../actions';
import CancelIcon from '@material-ui/icons/Cancel';
import IconButton from '@material-ui/core/IconButton';
import Cookies from 'js-cookie';
import './styles.css';

let iconsObj = {
  1: {
    icon: verydisappointed,
    iconFilled: verydisappointedfill,
    label: "Very Bad",
    filled: false,
    color: "#FF6B6B"
  },
  2: {
    icon: disappointed,
    iconFilled: disappointedfill,
    label: "Bad",
    filled: false,
    color: "#FB8A22"
  },
  3: {
    icon: neutral,
    iconFilled: neutralfill,
    label: "Average",
    filled: false,
    color: "#FFD63D"
  },
  4: {
    icon: satisfied,
    iconFilled: satisfiedfill,
    label: "Good",
    filled: false,
    color: "#7FE517"
  },
  5: {
    icon: verysatisfied,
    iconFilled: verysatisfiedfill,
    label: "Excellent",
    filled: false,
    color: "#01D301"
  }
};

export const SupportFeedback = React.memo((props) => {

  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const defaultBodyStyles = {
    padding: '10px 10px 30px 10px',
    fontSize: '14px',
    display: 'block !important',
    backgroundColor: '#4D4D4D',
  };

  const defaultMessageStylesTextarea = {
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontWeight: 500,
    width: '100%',
    padding: "10px",
    height: '64px',
    border: 'none',
    outline: 'none',
    borderRadius: '4px',
    border: '1px solid #9E9E9E',
    "&::placeholder": {    
      fontSize: '14px', 
      color: 'rgba(0, 0, 0, 0.54)',
      fontSize: '1rem',
      fontFamily: 'Montserrat',
      fontWeight: 400,
      lineHeight: 1
    }
  };

  const defaultMessageStyles = {
    display: 'flex',
    justifyContent: 'center',
    padding: '3px',
    fontSize: '14px',
    lineHeight: 1.43,
    resize: 'none',
    border: 'none',
    color: '#ffffff',
    fontWeight: '500',
    fontFamily: 'Montserrat',
    fontSize: '14px',
    paddingBottom: '8px'
  };

  const messageBoxStyles = {
    marginTop: '15px'
  }

  const thankYouStyles = {
    color: '#3EF450',
    fontWeight: '600',
    fontFamily: 'Montserrat',
    fontSize: '20px',
    textAlign: 'center'
  }

  const inputVitalStyles = {
    color: '#fff',
    fontWeight: '500',
    fontFamily: 'Montserrat',
    fontSize: '18px',
    paddingBottom: '14px',
    paddingTop: '4px',
    textAlign: 'center'
  }

  const thankYouContainer = {
    backgroundColor: '#4D4D4D'
  }

  const textAreaValidation = {
    color: '#fff',
    float: 'right'
  }

  const StyledRating = styled(Rating)(({ theme }) => ({
    '& .MuiRating-iconEmpty .MuiSvgIcon-root': {
      color: 'rgba(0, 0, 0, 0.26)',
    },
  }));

  const [customIcons, setCustomIcons] = useState(iconsObj)
  const [messageInput, setMessageInput] = useState("");
  const [ratingInput, setRatingInput] = useState(null);
  const [feedbackSubmitStatus, setFeedbackSubmitStatus] = useState(false);
  const [displayErr, showErr] = useState(false);

  useEffect(() => {
    const customIcon = { ...iconsObj };
    Object.keys(customIcon).forEach((index) => {
      customIcon[index].filled = false;
      customIcon[index].clicked = false;
    });
    setCustomIcons(customIcon);
  }, [props])

  const hoverIcons = (event, newHover) => {
    if (newHover === -1) {
      const customIcon = { ...customIcons };
      Object.keys(customIcons).map((index) => {
        if (!customIcon[index].clicked)
          customIcon[index].filled = false;
      });
      setCustomIcons(customIcon);
    }
    else {
      const value = newHover;
      const customIcon = { ...customIcons };
      Object.keys(customIcons).map((index) => {
        if (index !== value && !customIcon[index].clicked)
          customIcon[index].filled = false;
      });
      customIcon[value].filled = true;
      setCustomIcons(customIcon);
    }
  }

  const handleRating = (event, newValue) => {
    if (!newValue) return;
    const value = parseInt(newValue);
    const customIcon = { ...customIcons };
    Object.keys(customIcons).forEach((index) => {
      customIcon[index].filled = false;
      customIcon[index].clicked = false;
    });
    customIcon[value].filled = true;
    customIcon[value].clicked = true;
    setCustomIcons(customIcon);
    setRatingInput(value);
  }

    const IconContainer = (props) => {
      let { value, ...other } = props;

      value = parseInt(value);
      return <div {...other} style={{marginRight: 12}}><span>{customIcons[value]?.filled ? customIcons[value].iconFilled : customIcons[value].icon}</span><span className='tooltipText' style={{ backgroundColor: customIcons[value].color }}>{customIcons[value].label}</span></div>;
    }
    
    const calculateCommentLenth = () => {
      const length = messageInput?.length
      if (isNaN(length)) {
        return 0
      } else {
        return length
      }
    }

    const handleSubmitSurvey = async () => {
      showErr(false)
      if (((ratingInput == 1) || (ratingInput == 2)) && (messageInput.trim() == "")) {
        showErr(true)
      } else {
        const data = {
          "loanNumber": Cookies.get("selectedAccount"),
          "userName": "",
          "feedbackRating": ratingInput,
          "feedbackComment": messageInput.trim(),
          "feedbackType": "SupportFeedback",
          "ticketID": props.ticketID
        }
    
        const result = await updateMyFeedbackProtected(data);
        setCustomIcons(iconsObj)
        setRatingInput(null);
        setMessageInput("");
        setFeedbackSubmitStatus(true);
      }
    }

    return (
     <Dialog fullScreen={fullScreen} PaperProps={{ classes: { root: classes.dialogStyle }}} open={props.open}>
        <Box className={classes.root}>
          <IconButton onClick={() => {feedbackSubmitStatus ? props.handleFeedbackSubmit() : props.handleCancelIcon()}} className={classes.close}>
            <CancelIcon />
          </IconButton>
          <Box className={classes.cardBody}>
            <Typography className={classes.statusTitle}>We value your feedback!</Typography>
          </Box>
          <Box style={defaultBodyStyles}>
            {feedbackSubmitStatus ?
                <Box style={thankYouContainer}>
                  <Box style={{ textAlign: 'center', paddingTop: '14px' }}>
                    {checkmark}
                  </Box>
                  <Typography style={thankYouStyles}>THANK YOU!</Typography>
                  <Typography style={inputVitalStyles}>Your input is vital in helping us enhance our services.</Typography>
                  
                  <Box className={classes.cardFooter}>
                    <Button
                      variant='contained'
                      color='primary'
                      className={classes.btn}
                      onClick={props.handleFeedbackSubmit}
                      >Close</Button>
                  </Box>
                </Box>
               :
              <>
                  <Box className={classes.feedbackTitle}>Please rate your experience with this support ticket.</Box>
                  <Box style={defaultMessageStyles}>
                    <Rating
                      value={ratingInput}
                      name={'highlight-selected-only'}
                      className={classes.rating}
                      onChange={handleRating}
                      onChangeActive={hoverIcons}
                      // onChange={(event, newValue) => {
                      //   console.log(newValue)
                      //   handleRating(event, newValue)}}
                      IconContainerComponent={IconContainer}
                      // onChangeActive={(event, newHover) => hoverIcons(event, newHover)}
                      highlightSelectedOnly
                    />
                  </Box>

                {ratingInput != null &&
                  <>
                  <Box style={messageBoxStyles}>
                    <TextareaAutosize
                      value={messageInput}
                      placeholder="Tell us more..."
                      onChange={(e) => setMessageInput(e.target.value)}
                      style={defaultMessageStylesTextarea}
                      maxLength="500"
                    />
                    <Typography style={textAreaValidation}>{calculateCommentLenth()}/500</Typography>
                   {((ratingInput == 1) || (ratingInput == 2)) && (messageInput.trim() == "") && displayErr && <Typography className={classes.errorMsg}>Please provide a comment for this poor feedback.</Typography>}
                  </Box>
  
                    <Grid container className={classes.footerSection}>
                        <Grid item xs={5} md={6} className={classes.pr35}>
                          <Box className={classes.cancelBtnBox}>
                            <Button
                              className={classes.cancelBtn}
                              variant="contained"
                              color='primary'
                              onClick={props.handleCancelIcon}
                            >CANCEL</Button>
                          </Box>
                        </Grid>
                        <Grid item xs={7} md={6} className={classes.pl35}>
                          <Box className={classes.saveBtnBox}>
                              <Button
                                className={classes.saveBtn}
                                variant="contained"
                                onClick={handleSubmitSurvey}
                                color="primary">
                                SUBMIT</Button>
                          </Box>
                        </Grid>
                    </Grid>
                  </>  
            }
            </>
            }
          </Box>
        </Box>
    </Dialog>
  )
});
